export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";